import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Util } from '@grandvisionhq/common';
import { useIntl, useSelector, statusLoading, statusIdle, statusSuccess } from '@grandvisionhq/state';
import { getAddressBookList, getAddCall } from '../../../../AddressBook/selectors.js';
import { AddressBookModal } from './AddressBookModal.js';

var AddressBookModalContainer = (_param)=>{
    var { addressSummary , addressForm , onAddAddress , onSelectAddress , initialSelectedAddress  } = _param, modalProps = swcHelpers.objectWithoutProperties(_param, [
        "addressSummary",
        "addressForm",
        "onAddAddress",
        "onSelectAddress",
        "initialSelectedAddress"
    ]);
    const { getLabel  } = useIntl();
    const [activeComponentKey, setActiveComponentKey] = React.useState('select');
    const [selectedAddress, setSelectedAddress] = React.useState(initialSelectedAddress);
    const addressList = useSelector(getAddressBookList);
    const addCall = useSelector(getAddCall);
    const isAddCallLoading = statusLoading(addCall);
    const previousAddCall = Util.usePrevious(addCall);
    React.useEffect(()=>{
        setSelectedAddress(initialSelectedAddress);
    }, [
        initialSelectedAddress
    ]);
    React.useEffect(()=>{
        if (previousAddCall && statusLoading(previousAddCall) && statusIdle(addCall)) {
            setActiveComponentKey('select');
            // Grab the last added address
            if (statusSuccess(addressList)) {
                setSelectedAddress(addressList.result[0]);
            }
        }
    }, [
        previousAddCall,
        addCall,
        addressList,
        selectedAddress,
        setSelectedAddress,
        setActiveComponentKey, 
    ]);
    const handleAdressSelect = React.useCallback(()=>{
        selectedAddress && onSelectAddress(selectedAddress);
    }, [
        selectedAddress,
        onSelectAddress
    ]);
    const handleOnAddAddress = React.useCallback(()=>{
        setActiveComponentKey('add');
    }, [
        setActiveComponentKey
    ]);
    const isAddViewActive = activeComponentKey === 'add';
    const secondaryIconOptions = isAddViewActive ? {
        'aria-label': getLabel('common.actions.previous'),
        name: 'chevron-left',
        onClick: ()=>setActiveComponentKey('select')
    } : undefined;
    const labels = React.useMemo(()=>({
            title: isAddViewActive ? getLabel('checkout.addressBook.newAddress.title') : getLabel('checkout.addressBook.selectAddress.title'),
            save: getLabel('checkout.addressBook.newAddress.save'),
            add: getLabel('checkout.addressBook.newAddress.add'),
            select: getLabel('checkout.addressBook.selectAddress.select')
        })
    , [
        isAddViewActive,
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(AddressBookModal, swcHelpers.extends({}, modalProps, {
        activeComponentKey: activeComponentKey,
        addCall: addCall,
        addressForm: addressForm,
        addressSummary: addressSummary,
        handleOnAddAddress: handleOnAddAddress,
        handleAdressSelect: handleAdressSelect,
        isAddCallLoading: isAddCallLoading,
        isAddViewActive: isAddViewActive,
        labels: labels,
        onAddAddress: onAddAddress,
        onSelectAddress: onSelectAddress,
        secondaryIconOptions: secondaryIconOptions,
        selectedAddress: selectedAddress,
        setActiveComponentKey: setActiveComponentKey,
        setSelectedAddress: setSelectedAddress
    }));
};

export { AddressBookModalContainer };
//# sourceMappingURL=AddressBookModalContainer.js.map
